import { DeliveryServicesUI } from "./DeliveryServicesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";

export function DeliveryServices({
  product,
  configProps,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "flags">) {
  const { variant } = useVariant(product);
  const { services = [] } = variant;
  const versionThreePromoDrawer = flags.versionThreePromoDrawer.value;
  const enableServiceQuestionnaireDrawer =
    flags.enableServiceQuestionnaireDrawer.value === true;

  const deliveryServices = services.filter(({ __typename }) =>
    ["DeliveryService"].includes(__typename),
  );

  const hasDeliveryServices = (deliveryServices ?? []).length > 0;

  const deliveryServiceQuestionnaireEnabled =
    Boolean(configProps?.deliveryServiceQuestionnaireEnabled) || false;

  if (!hasDeliveryServices) return null;

  return (
    <DeliveryServicesUI
      availableToOrder={variant?.availability?.availableToOrder || false}
      variantServices={deliveryServices}
      deliveryServiceQuestionnaireEnabled={deliveryServiceQuestionnaireEnabled}
      showFreeServicePromoTag={!!versionThreePromoDrawer}
      enableServiceQuestionnaireDrawer={enableServiceQuestionnaireDrawer}
    />
  );
}
